export default __webpack_public_path__ + "static/media/brands.81addb2b.svg";